import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authService } from '../services/authService';
import toast from 'react-hot-toast';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      isLoading: false,
      error: null,
      
      login: async (email, password) => {
        set({ isLoading: true, error: null });
        try {
          const user = await authService.login(email, password);
          set({ user, isLoading: false });
          
          // Show different welcome messages
          if (user.role === 'admin') {
            toast.success('Welcome back, Admin!');
          } else {
            toast.success('Welcome back!');
          }
          
          return user;
        } catch (error) {
          set({ error: error.message, isLoading: false });
          toast.error(error.message);
          throw error;
        }
      },
      
      register: async (userData) => {
        set({ isLoading: true, error: null });
        try {
          const user = await authService.register(userData);
          set({ user, isLoading: false });
          toast.success('Account created successfully!');
          return user;
        } catch (error) {
          set({ error: error.message, isLoading: false });
          toast.error(error.message);
          throw error;
        }
      },
      
      logout: async () => {
        try {
          await authService.logout();
          set({ user: null, error: null });
          toast.success('Logged out successfully');
        } catch (error) {
          toast.error('Error logging out');
        }
      },
      
      clearError: () => set({ error: null }),
      
      // Initialize user from localStorage on app start
      initializeUser: async () => {
        try {
          const user = await authService.getCurrentUser();
          if (user) {
            set({ user });
          }
        } catch (error) {
          console.error('Failed to initialize user:', error);
        }
      }
    }),
    {
      name: 'auth-storage',
      // Don't persist the user object, we'll get it from localStorage
      partialize: (state) => ({ user: state.user }),
    }
  )
);